import ApiService from '@/services/core/api.service'

const PendingService = {
  async get (query = '') {
    return ApiService.get(`user/payment-approvals?${query}`)
  },

  async show (id) {
    return ApiService.get(`user/payment-approvals/${id}`)
  },

  async post (payload) {
    return ApiService.post('user/payment-approvals', payload)
  },

  async put (payload) {
    return ApiService.put(`user/payment-approvals/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`user/payment-approvals/${payload.id}`)
  }
}

export default PendingService
